export default "__VITE_ASSET__ZMlqTeLo__"